import { render, staticRenderFns } from "./TheAppBar.vue?vue&type=template&id=466ecb96"
import script from "./TheAppBar.vue?vue&type=script&lang=js"
export * from "./TheAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChooseSalonDialog: require('/salonhomepage/client/components/chooseSalonDialog.vue').default})
